import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import Api from "../../lib/componentApi";
import mixpanel from "../../lib/mixPanel";
import submitPlace from "../../lib/submitPlace";
import getAppErrors from "../../lib/appErrors";
import getComponentData from "../../lib/getComponentData";

// import CommonHeader from "./Header/";
import AppErrors from "./AppErrors";

import Terms from "../../routes/screens/Common/Terms";
import Privacy from "../../routes/screens/Common/Privacy";
import Search from "../../routes/screens/Restaurants/Search";

///Components
import Rate from "../Users/Orders/Rate";
import MobileFooter from "./components/PreLogin/MobileFooter";
import PostLoginCategories from "./components/PostLogin/PostLoginCategories";
import PostLoginOrders from "./components/PostLogin/PostLoginOrders";
import PostLoginHead from "./components/PostLogin/PostLoginHead";
import setLocalDeliveryData from "../../lib/setLocalDeliveryData";
import Cookies from "../../routes/screens/Common/Cookies";
import getRestaurantsLink from "../../lib/getRestaurantsLink";
import AppCenteredInfo from "./AppCenteredInfo";
import getLocalData from "../../lib/getLocalData";

class PostLogin extends Component {
  constructor(props) {
    super(props);
    const staticContext = props.staticContext;
    let popularCategories = [],
      notPopularCategories = [],
      pastOrders = [],
      recentOrders = [];
    const { initialData, otherData } = getComponentData(
      staticContext,
      "searchCategories",
      "orders"
    );
    if (initialData && initialData.length) {
      popularCategories = initialData.filter(category => category.isPopular);
      notPopularCategories = initialData.filter(
        category => !category.isPopular
      );
    }
    if (otherData) {
      pastOrders = otherData.pastOrders;
      recentOrders = otherData.recentOrders;
    }
    const lastAddressId = getLocalData("lastAddressId");
    const address =
      props.user.addresses.find(address => address.id === lastAddressId) ||
      props.user.addresses[0] ||
      {};

    this.state = {
      addressId: address.id || "",
      routeName: address.addressLine1 || "",
      title: address.title || "",
      postalCode: address.postalCode || "",
      privacySection: false,
      termsSection: false,
      cookiesSection: false,
      pastOrders,
      recentOrders,
      popularCategories,
      notPopularCategories,
      errorMessage: null,
      orderUid: null,
      rateSection: false,
      city: (address.city && address.city.slugName) || "",
      adminWard: address.slugAdminWard || "",
      rateYourMeal: false,
      rateMessage: ""
    };
  }
  componentDidMount() {
    const { pastOrders } = this.state;
    const lastPastOrder = pastOrders[0] || {};

    if (lastPastOrder) {
      if (this.checkLastOrderRate(lastPastOrder)) {
        var body = document.body;
        body.classList.add("body-overflow");
        const rateMessage = this.generateMealMessage(lastPastOrder);
        this.setState({
          rateYourMeal: true,
          orderUid: lastPastOrder.uid,
          rateMessage
        });
      }
    }
  }
  generateMealMessage = order => {
    const { restaurant } = order;
    const orderDate = moment
      .utc(order.orderDate)
      .local()
      .format("DD MMMM HH:mm");
    let rateMessageBegin = `<p class="blue-text">${restaurant.name}</p><p>${orderDate}</p><hr />`;
    const rateMessageEnd = "</div>";
    order.items.forEach(item => {
      if (item.id) {
        const message = `<div class="d-flex align-items-center justify-content-between"><p>${item.name}</p><p>x${item.quantity}</p></div>`;
        rateMessageBegin += message;
      }
    });
    return rateMessageBegin + rateMessageEnd;
  };
  checkLastOrderRate = lastPastOrder => {
    return (
      lastPastOrder.uid &&
      lastPastOrder.status === "ORDER_COMPLETED" &&
      lastPastOrder.userCanRate &&
      getLocalData("userCanRate") === "true"
    );
  };
  onClickClose = status => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({
      [status]: false
    });
  };
  openPrivacySection = () => {
    mixpanel.track("Privacy Click");
    this.setState({ privacySection: true });
  };
  openTermsSection = () => {
    mixpanel.track("Terms Click");
    this.setState({ termsSection: true });
  };
  openCookiesSection = () => {
    mixpanel.track("Cookies Click");
    this.setState({ cookiesSection: true });
  };
  handleSelectAddress = item => {
    const { id, addressLine1, title, postalCode, slugAdminWard, city } =
      item || null;
    this.setState({
      addressId: id,
      routeName: addressLine1,
      title,
      postalCode,
      city: (city && city.slugName) || "",
      adminWard: slugAdminWard
    });
  };
  handleReOrder = orderUid => {
    var body = document.body;
    Api.post("/api/order/reorder", { orderUid }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code) || null;
        body.classList.add("body-overflow");
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        if (response.status) {
          mixpanel.track("Checkout Screen", { _source: "Reorder" });
          window.location.href = "/checkout";
        } else {
          body.classList.add("body-overflow");
          this.setState({
            errorMessage: "The restaurant is not available for the order."
          });
        }
      }
    });
  };
  handleRateOrder = orderUid => {
    var body = document.body;
    if (orderUid) {
      body.classList.add("body-overflow");
      this.setState({
        orderUid,
        rateSection: true
      });
    }
  };
  setLocalDataCallback = addressData => {
    window.location.href = `/restaurants/${addressData.city}/${addressData.adminWard}/?postcode=${addressData.postalCode}&time=now`;
  };
  handleFindRestaurants = event => {
    event.preventDefault();
    const { user } = this.props;
    localStorage.removeItem("deliveryDetails");
    const {
      addressId,
      routeName,
      title,
      postalCode,
      adminWard,
      city,
      adminWardName
    } = this.state;
    localStorage.setItem("lastAddressId", addressId);
    const addressData = {
      userAddressId: parseInt(addressId),
      routeName,
      title,
      postalCode,
      delivery: true,
      uid: user.uid,
      adminWard,
      adminWardName,
      city
    };
    if (city) {
      const jsonData = JSON.stringify(addressData);
      setLocalDeliveryData(jsonData, () =>
        this.setLocalDataCallback(addressData)
      );
    } else {
      window.location.href = "/unavaliable";
    }
  };
  handleError = errorMessage => {
    if (errorMessage === 503) {
      this.setState(() => {
        throw errorMessage;
      });
    } else {
      this.setState({ errorMessage });
    }
  };
  onSubmitPlace = async place => {
    const { user } = this.props;
    const userUid = user.uid;
    await submitPlace(place, "list", this.handleError, userUid);
  };
  handleOrderDetail = orderUid => {
    if (orderUid) {
      window.location.href = `/profile?orders#${orderUid}`;
    }
  };
  getOrderDate = orderDate => {
    if (orderDate) {
      const formattedDate = moment
        .utc(orderDate)
        .local()
        .format("MMMM DD, YYYY HH:mm");
      return formattedDate;
    }
  };
  handleSubmitRate = rateData => {
    const { rateMessage } = this.state;
    Api.post("/api/order/rate", rateData, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code) || null;
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        if (response.status) {
          if (rateMessage) {
            localStorage.setItem("userCanRate", "false");
          }
          this.setState({
            rateSection: false,
            orderUid: "",
            rateMessage: ""
          });
          location.reload();
        }
      }
    });
  };
  onSubmitCategory = (
    categoryName,
    type,
    restaurantPostCode,
    restaurantAdminWard,
    restaurantCity,
    slugName
  ) => {
    mixpanel.track("Click Popular Category", {
      Category: categoryName
    });
    if (categoryName === "My Favorites") {
      location.href = "/profile?favorites";
    } else {
      if (type === 1) {
        const { postalCode, preOrder } = this.state;
        const href = `/restaurant/${restaurantCity}/${restaurantAdminWard}/${slugName}/?postcode=${postalCode ||
          restaurantPostCode}&time=${preOrder || "now"}`;
        if (href) {
          location.href = href;
        }
      } else {
        const link = getRestaurantsLink();
        let href;
        if (link !== "/") {
          href = `${link}&query=${categoryName}`;
        } else {
          href = link;
        }

        if (href) {
          location.replace(href);
        }
      }
    }
  };
  onCloseRateMeal = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState(
      {
        orderUid: null,
        rateYourMeal: false
      },
      () => {
        localStorage.setItem("userCanRate", "false");
      }
    );
  };
  onSubmitRateMeal = () => {
    const { orderUid } = this.state;
    this.setState(
      {
        rateYourMeal: false
      },
      () => {
        if (orderUid) {
          this.setState({ rateSection: true });
        }
      }
    );
  };
  render() {
    const {
      termsSection,
      cookiesSection,
      privacySection,
      popularCategories,
      notPopularCategories,
      pastOrders,
      recentOrders,
      errorMessage,
      routeName,
      title,
      rateSection,
      orderUid,
      rateYourMeal,
      rateMessage
    } = this.state;
    const { user } = this.props;

    return (
      (termsSection && <Terms onClickClose={this.onClickClose} />) ||
      (privacySection && <Privacy onClickClose={this.onClickClose} />) ||
      (cookiesSection && <Cookies onClickClose={this.onClickClose} />) ||
      (user && (
        <div className="main-page post-login">
          {/* <CommonHeader /> */}

          <PostLoginHead
            user={user}
            title={title}
            routeName={routeName}
            handleSelectAddress={this.handleSelectAddress}
            handleFindRestaurants={this.handleFindRestaurants}
            onSubmitPlace={this.onSubmitPlace}
          />
          {/* .image-section */}
          {rateSection && (
            <Rate
              onClickClose={() => this.onClickClose("rateSection")}
              orderUid={orderUid}
              onSubmitRate={this.handleSubmitRate}
            />
          )}
          <div className="container">
            <div className="row">
              {((pastOrders.length || recentOrders.length) && (
                <React.Fragment>
                  <PostLoginOrders
                    pastOrders={pastOrders}
                    recentOrders={recentOrders}
                    handleOrderDetail={this.handleOrderDetail}
                    getOrderDate={this.getOrderDate}
                    handleRateOrder={this.handleRateOrder}
                    handleReOrder={this.handleReOrder}
                  />
                  <PostLoginCategories
                    popularCategories={popularCategories}
                    onSubmitCategory={this.onSubmitCategory}
                  />
                </React.Fragment>
              )) || (
                <Search
                  notPopularCategories={notPopularCategories}
                  popularCategories={popularCategories}
                  postLogin={true}
                />
              )}
            </div>
            <MobileFooter
              openPrivacySection={this.openPrivacySection}
              openTermsSection={this.openTermsSection}
              openCookiesSection={this.openCookiesSection}
            />
          </div>
          {rateYourMeal && (
            <AppCenteredInfo
              message={rateMessage}
              buttonText="Get 100 eCoins!"
              headerTitle="Rate your meal?"
              bodyClass="rate-meal-body"
              titleClass="rate-meal-title"
              onSubmit={this.onSubmitRateMeal}
              onClickClose={this.onCloseRateMeal}
            />
          )}
          {(errorMessage && (
            <AppErrors
              message={errorMessage}
              onClickClose={() => this.onClickClose("errorMessage")}
            />
          )) || <noscript />}
        </div>
      )) || <div />
    );
  }
}

export default withRouter(PostLogin);
